/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from './@core/utils/analytics.service';

import { LanguageService } from './_services/index';

import { TranslateService } from '@ngx-translate/core';

import { QRCodeComponent } from 'angularx-qrcode';

import { environment } from './../environments/environment';

@Component({
    selector: 'ngx-app',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService,
    public translate: TranslateService,
    public languageService: LanguageService,
    private titleService: Title) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();

    this.titleService.setTitle(environment.title);
    this.initTranslate();

    google.maps.importLibrary("maps");
    google.maps.importLibrary("places");
    google.maps.importLibrary("core");
  }

  initTranslate(){
    //Language config
    console.log('translate.getBrowserLang():'+this.translate.getBrowserLang());
    this.translate.addLangs(["en", "fr", "nl"]);
    this.translate.setFallbackLang('en');

    var storedLocale = localStorage.getItem('locale');
		if(storedLocale){
			console.log('Found stored locale:'+storedLocale);
			var locale = JSON.parse(storedLocale);
			this.translate.use(locale);
			console.log('Current lang:'+this.translate.currentLang);
    }
    else{
      let browserLang = this.translate.getBrowserLang();
      this.translate.use(browserLang.match(/en|fr|nl/) ? browserLang : 'en');
    }

    this.languageService.currentLang = this.translate.currentLang;
  }
}
